module.exports = __webpack_public_path__ + "assets/img/btn-download-steam-1092cb04.png";